export type ShellNavDirection = 'forward' | 'back';

let pendingDirection: ShellNavDirection = 'forward';

export function setPendingShellNavDirection(direction: ShellNavDirection): void {
  pendingDirection = direction;
  document.documentElement.dataset.shellNav = direction;
}

export function pageEnterClassForDirection(direction: ShellNavDirection = pendingDirection): string {
  return direction === 'back' ? 'md-page-enter-back' : 'md-page-enter-forward';
}

function ensureRouteAnnouncer(): HTMLElement {
  let el = document.getElementById('shell-route-announcer');
  if (el) return el;
  el = document.createElement('div');
  el.id = 'shell-route-announcer';
  el.className = 'shell-route-announcer';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-atomic', 'true');
  document.body.append(el);
  return el;
}

/** Screen reader announcement for route / page changes. */
export function announceShellRoute(message: string): void {
  const text = message.trim();
  if (!text) return;
  const el = ensureRouteAnnouncer();
  el.textContent = '';
  requestAnimationFrame(() => {
    el.textContent = text;
  });
}

/** Moves screen reader / keyboard focus to the page title after route swap. */
export function focusMainPageHeading(main: HTMLElement): void {
  queueMicrotask(() => {
    const page = main.firstElementChild;
    if (!page) return;
    const root = page.shadowRoot ?? page;
    const heading = root.querySelector('h1');
    if (!(heading instanceof HTMLElement)) return;
    const text = heading.textContent?.trim() ?? '';
    if (text) announceShellRoute(text);
    heading.tabIndex = -1;
    heading.focus({ preventScroll: true });
  });
}
